export const TaskType = {
	adsync: 'adsync',
	dssync: 'dssync',
	rebuildsearchindex: 'rebuildsearchindex'
}